# GraphQL mutation to create a stage

#import "../fragments/stage-lead-user-assignment-data-fragment.graphql"

mutation SetStageLeadAssignmentAutomation(
    $stageLeadAssignmentAutomation: SetStageLeadAssignmentAutomationInputFieldInput!
) {
    setStageLeadAssignmentAutomation(
        input: {stageLeadAssignmentAutomation: $stageLeadAssignmentAutomation}
    ) {
        stage {
            ...StageLeadUserAssignmentData
        }
    }
}
